<template>
    <div id="page_07" class="page">
        <div class="content">
            <div class="content_area">
                <div style="font-weight:bold;">
                    INTERIOR &amp; EXTERIOR
                </div>
                <div style="margin-top:2.212rem;">
                    <img src="@/assets/img/img_page_07_01.jpg" style="width:22.52rem;"  />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Page07"
}
</script>

<style scoped>
    .content{padding-bottom:3.434rem;padding-top:1.8rem;}
    .content_area>div{text-align:center;}
</style>


